<script>
import { mapState } from "vuex";

export default {
	name: "compKeluargaKatoliksDetail",
	data() {
		return {};
	},

	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatBabtisItem: (state) => state.umatBaptis.item,
			keluargaKatolikItem: (state) => state.keluargaKatolik.item,
		}),
	},
};
</script>

<template>
	<div class="card">
		<div class="card-body">
			<div class="invoice text-left">
				<div>
					<div>
						<div class="row">
							<div class="col-sm-12">
								<div class="media">
									<div class="media-left">
										<img
											class="media-object img-60"
											src="../../assets/images/logo.png"
											alt
										/>
									</div>
									<div class="media-body m-l-20">
										<h4 class="media-heading">
											Kartu Keluarga Katolik Keuskupan Sintang
										</h4>
									</div>
								</div>
								<!-- End Info-->
							</div>
						</div>
					</div>
					<hr />
					<!-- End InvoiceTop-->
					<div class="row">
						<div class="col-md-6">
							<table width="100%">
								<tbody>
									<tr>
										<td width="20%"><b>Paroki</b></td>
										<td width="2%">:</td>
										<td width="50%">
											{{ keluargaKatolikItem.paroki }}
										</td>
									</tr>
									<tr>
										<td><b>Lingkungan/Stasi</b></td>
										<td>:</td>
										<td>
											{{ keluargaKatolikItem.lingkungan_stasi }}
										</td>
									</tr>
									<tr>
										<td><b>Kota/Kabupaten</b></td>
										<td>:</td>
										<td>{{ keluargaKatolikItem.kabupaten }}</td>
									</tr>
									<tr>
										<td><b>Kecamatan</b></td>
										<td>:</td>
										<td>{{ keluargaKatolikItem.kecamatan }}</td>
									</tr>
									<tr>
										<td><b>Kelurahan/Desa</b></td>
										<td>:</td>
										<td>{{ keluargaKatolikItem.desa }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="col-md-6">
							<table width="100%">
								<tbody>
									<tr>
										<td width="20%"><b>No. LM</b></td>
										<td width="2%">:</td>
										<td width="50%">
											{{ keluargaKatolikItem.nomor }}
										</td>
									</tr>
									<tr>
										<td><b>Kepala Keluarga</b></td>
										<td>:</td>
										<td>{{ keluargaKatolikItem.kepala_keluarga }}</td>
									</tr>
									<tr>
										<td><b>No. HP</b></td>
										<td>:</td>
										<td>{{ keluargaKatolikItem.nohp }}</td>
									</tr>
									<tr>
										<td><b>Alamat</b></td>
										<td>:</td>
										<td>{{ keluargaKatolikItem.alamat }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<!-- End Invoice Mid-->
					<div>
						<div class="table-responsive invoice-table">
							<table class="table table-bordered table-striped">
								<thead class="thead-light">
									<tr>
										<th class="text-center">No.</th>
										<th class="text-center">Nama</th>
										<th class="text-center">Hubungan Keluarga</th>
										<th class="text-center">L/P</th>
										<th class="text-center">TTL</th>
										<th class="text-center">Agama</th>
										<th class="text-center">Pendidikan</th>
										<th class="text-center">Pekerjaan</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="item in keluargaKatolikItem.anggota"
										:key="item.id"
									>
										<td class="text-center">{{ item.no }}</td>
										<td>{{ item.nama }}</td>
										<td>{{ item.hubungan }}</td>
										<td class="text-center">{{ item.jk }}</td>
										<td>
											{{ item.tempat_lahir }},
											{{
												$moment(item.tgl_lahir).format(
													"DD MMMM YYYY"
												)
											}}
										</td>
										<td>{{ item.agama }}</td>
										<td>{{ item.pendidikan }}</td>
										<td>{{ item.pekerjaan }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<!-- End InvoiceBot-->
				</div>
				<!-- <div class="col-sm-12 text-center mt-5">
					<button
						class="btn btn btn-primary"
						type="button"
						@click="printWindow()"
					>
						Download
					</button>
				</div> -->
				<!-- End Invoice-->
				<!-- End Invoice Holder-->
			</div>
		</div>
	</div>
</template>

